import { LIST_ROWS_PER_PAGE } from '../../../constants';
import { EVENT_TYPE_FILTERS } from '../../Events/eventTypes';

/** GET /admin/partner/events?tab=… */
export const PARTNER_EVENT_STATUS_TABS = [
  { label: 'All Events', tab: 'all' },
  { label: 'Drafts', tab: 'draft' },
  { label: 'Submitted', tab: 'submitted' },
  { label: 'Approved', tab: 'approved' },
  { label: 'Live', tab: 'live' },
  { label: 'Completed', tab: 'completed' },
  { label: 'Archived', tab: 'archived' },
];

export const getPartnerEventTabConfig = (tabIndex) =>
  PARTNER_EVENT_STATUS_TABS[tabIndex] ?? PARTNER_EVENT_STATUS_TABS[0];

/** List tabs where row actions are view-only (no edit, archive, or submit). */
const PARTNER_VIEW_ONLY_TABS = new Set(['completed', 'archived']);

export const isPartnerViewOnlyTab = (tabIndex) =>
  PARTNER_VIEW_ONLY_TABS.has(getPartnerEventTabConfig(tabIndex).tab);

export const PARTNER_EVENTS_PER_PAGE = LIST_ROWS_PER_PAGE;

export { EVENT_TYPE_FILTERS };

/**
 * @param {{ page: number, limit: number, tabIndex: number, search?: string, categoryType?: string }} options
 */
export const buildPartnerEventsListQueryParams = ({
  page,
  limit,
  tabIndex,
  search = '',
  categoryType = '',
}) => {
  const tabConfig = getPartnerEventTabConfig(tabIndex);
  const params = {
    tab: tabConfig.tab,
    page,
    limit,
  };

  if (search) params.search = search;
  if (categoryType) params.types = categoryType;

  return params;
};
